// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1332":"bf5bbde8","1679":"bf5bbde8","1704":"e9bea1dd","3154":"df7459f9","3349":"790d801d","3648":"3e611938","4320":"88751eef","5593":"9e427cce","5883":"3e611938"}[chunkId] + ".chunk.css";
};